import { Component } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, distinctUntilChanged, map, startWith, switchMap } from 'rxjs/operators';
import { DwUserEntity } from '../../../meta-data/app-meta-data.service';
import { StreakerCentralStateService } from '../services/streaker-central-state.service';

import { CentralDataService } from '../services/central-data.service';
import { userProfilePath } from '../../shared/services/profile-routing/profile-links';

/** Compact Fitness identity card; CAP owns user and media reads. */
@Component({
    selector: 'app-central-user',
    template: `
<ng-container *ngIf="state.state$ | async as vm"><ng-container *ngIf="{value: user$ | async} as identity"><section class="central-card central-user">
  <a class="central-user-link" routerLink="/my-profile" aria-label="My Profile"></a>
  <app-avatar-banner [appearance]="identity.value?.UserProfile" [name]="identity.value ? name(identity.value) : 'My profile'" [avatarMediaId]="identity.value?.UserPictureMediaId" [bannerMediaId]="identity.value?.UserBackgroundMediaId" [fitName]="true">
  </app-avatar-banner>
  <div class="central-user-body" [ngSwitch]="vm.membership">
    <ng-container *ngSwitchCase="'registered'">
      <ng-container [ngSwitch]="vm.mode">
        <ng-container *ngSwitchCase="'during-streak'"><span class="central-kicker">Your streak</span><h2>Your season is underway.</h2><p>Keep your daily routine going and follow your progress in Stats.</p></ng-container>
        <ng-container *ngSwitchCase="'after-streak'"><h2>Season complete</h2><p>Thank you for streaking with us.</p></ng-container>
        <ng-container *ngSwitchDefault><p>You're ready for {{ vm.challenge?.Name }}.</p></ng-container>
      </ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="'unregistered'"><h2>Your next streak starts here.</h2><p class="central-muted">Register for this challenge to join the season.</p></ng-container>
  </div>
<div class="central-user-body central-user-badges"><app-mini-badge-collection *ngIf="vm.participant?.UserChallengeId" [challengeId]="vm.challenge.ChallengeDefinitionId" [enrollmentId]="vm.participant.UserChallengeId" [profilePath]="profileLink(identity.value)" title="Your badges"></app-mini-badge-collection></div></section></ng-container></ng-container>`,
    styles: [`.central-user {position:relative;} .central-user-link {position:absolute;inset:0;z-index:3;border-radius:inherit;} .central-user-badges {position:relative;z-index:4;} .central-user-link:focus-visible {outline:3px solid var(--dw-fitness-countdown-accent);outline-offset:-3px;}`],
})
export class CentralUserComponent {
    readonly user$: Observable<DwUserEntity>;
    constructor(public state: StreakerCentralStateService, data: CentralDataService) {
        this.user$ = state.state$.pipe(map(vm => vm.userId), distinctUntilChanged(), switchMap(userId => {
            if (!userId) { return of(null); }
            return data.identity(userId).pipe( catchError(() => of(null)), startWith(null));
        }));
    }
    profileLink(user: DwUserEntity): string {
        const slug = this.state.state.profile?.ProfileSlug ||
            (user?.UserProfile?.UserId === user?.UserId ? user?.UserProfile?.ProfileSlug : null);
        return slug ? userProfilePath(slug) : null;
    }
    name(user: DwUserEntity): string { return [user.FirstName, user.LastName].filter(Boolean).join(' ') || 'My profile'; }
    initials(user: DwUserEntity): string { return [user.FirstName, user.LastName].filter(Boolean).map(value => value.charAt(0)).join('').toUpperCase() || 'S'; }
}
